<template>
  <div class="success-page">
    <div class="center-screen">
      <img
        src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
        alt="Check icon"
        class="centered-icon"
      />
    </div>

    <h2><b>Fast fertig</b></h2>
    <br />
    <p class="description">
      Vielen Dank für den erfolgreichen Abschluss. So geht's jetzt weiter –
      Schritt für Schritt:
    </p>

    <div class="icon-section">
      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              fill="#f9b218"
              d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
            />
          </svg>
        </div>
        <h3>Video –Identifikation Starten</h3>
        <p>
          Sie werden direkt auf die Seite von „CRIF-Videoidentifikation“
          weitergeleitet und erhalten Ihre Vorgangsnummer. Nun müssen Sie die
          Identifikation per Video-Anruf durch „Browser-Videotelefonie starten“
          beginnen
        </p>
      </div>

      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              fill="#f9b218"
              d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
            />
          </svg>
        </div>
        <h3>Identifizierung</h3>
        <p>
          Starten Sie Ihr Videotelefonat. Der Mitarbeiter fragt Sie unter
          anderem nach Ihrer Vorgangsnummer. Schritt für Schritt werden Sie vom
          Mitarbeiter durch die Legitimation geführt.
        </p>
      </div>

      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
            <path
              fill="#f9b218"
              d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l293.1 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1l-91.4 0zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
            />
          </svg>
        </div>
        <h3>Identifizierung abschließen</h3>
        <p>
          Sie erhalten beim Videotelefonat per Mail oder SMS eine TAN. Nach der
          erfolgreichen Videoidentifikation kommen Sie direkt zum
          Vertragsabschluss. Hier können Sie einfach, sicher und schnell Ihren
          Vertrag Digital rechtsgültig abschließen
        </p>
      </div>

      <div class="icon-item">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path
              fill="#f9b218"
              d="M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
            />
          </svg>
        </div>
        <h3>IBAN-Erhalt & Einzahlung</h3>
        <p>
          Ihre persönliche IBAN erhalten Sie von uns in der Regel innerhalb von
          1–2 Bankwerktagen. Damit ist alles bereit für Ihre Einzahlung – und
          Ihre Veranlagung kann starten.
        </p>
      </div>
    </div>

    <!-- here the old one  -->

    <div class="p-2 w-full">
      <div v-if="validGuid" :guid="guid">
        <GoToCrif
          v-if="validGuid"
          :guid="guid"
          :is-gemeinschaftskonto="isGemeinschaftskonto"
        />
        <!-- <div class="mt-12">
            <Divider />
          </div> -->
        <section v-if="pdfLocation" class="flex justify-center flex-col my-4">
          <div class="max-w-md mx-auto text-center">
            <p>
              Hier können Sie
              <a :href="pdfLocation" target="_blank" class="underline" download>
                das PDF herunterladen
              </a>
              <br />
              Bitte schließen Sie die Identifikation ab, um den Prozess
              abzuschließen.
            </p>
          </div>
        </section>

        <div>
          <CustomModal :show="showModal">
            <form
              class="text-center mt-9 flex justify-center flex-col"
              @submit="sendQuestions"
              @submit.prevent="onSubmit"
            >
              <fieldset :class="fieldsetClass">
                <p class="text-sm italic">{{ $t("chooseOptionNicely") }}:</p>
                <legend class="font-bold">
                  Wie Sind Sie auf uns aufmerksam geworden?
                </legend>
                <div class="flex align-middle items-center">
                  <input
                    class="checkbox"
                    id="bestKunde"
                    v-model="umfrage.bestehenderKunde"
                    type="checkbox"
                  />
                  <label class="block text-sm py-3 px-2" for="bestKunde">
                    Bestehender Kunde
                  </label>
                </div>
                <div class="flex align-middle items-center">
                  <input
                    class="checkbox"
                    id="zeitung"
                    v-model="umfrage.zeitung"
                    type="checkbox"
                  />
                  <label class="block text-sm py-3 px-2" for="zeitung"
                    >Zeitung</label
                  >
                </div>
                <div class="flex align-middle items-center">
                  <input
                    class="checkbox"
                    id="internet"
                    v-model="umfrage.internet"
                    type="checkbox"
                  />
                  <label class="block text-sm py-3 px-2" for="internet"
                    >Internet / Homepage</label
                  >
                </div>
                <div class="flex align-middle items-center">
                  <input
                    class="checkbox"
                    id="durchblicker"
                    v-model="umfrage.durchblicker"
                    type="checkbox"
                  />
                  <label class="block text-sm py-3 px-2" for="durchblicker"
                    >Durchblicker.at</label
                  >
                </div>
                <div class="flex align-middle items-center">
                  <input
                    class="checkbox"
                    id="freunde"
                    v-model="umfrage.freunde"
                    type="checkbox"
                  />
                  <label class="block text-sm py-3 px-2" for="freunde"
                    >Freunde / Bekannte</label
                  >
                </div>
                <div class="flex align-middle items-center">
                  <input
                    class="checkbox"
                    id="sonstige"
                    v-model="umfrage.sonstige"
                    type="checkbox"
                  />
                  <label class="block text-sm py-3 px-2" for="sonstige"
                    >Sonstiges
                  </label>
                </div>
                <div v-if="umfrage.sonstige">
                  <label
                    class="block text-sm font-bold mb-2"
                    for="sonstiges_text"
                    >Sonstiges (Erkärung):</label
                  >
                  <input
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="sonstiges_text"
                    v-model="umfrage.sonstige_txt"
                    type="text"
                    required
                    aria-required="true"
                    :placeholder="$t('description')"
                  />
                </div>
              </fieldset>
              <div>
                <button class="btn btn-primary">Senden</button>
              </div>
            </form>
          </CustomModal>
        </div>
      </div>
      <div v-else>
        <div v-if="loading">
          <LoadingCircle />
        </div>
        <div v-else>
          <h1>Leider hat das nicht geklappt...</h1>
          <p>
            Ein Fehler ist aufgetreten.
            <a href="https://www.vakifbank.at">Hier</a> kommen Sie zurück zu
            unserer Homepage.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
/* import Divider from "@/components/Divider.vue";
 */ import GoToCrif from "@/components/GoToCrif.vue";
import CustomModal from "@/components/CustomModal.vue";
import LoadingCircle from "@/components/LoadingCircle.vue";

export default {
  components: { GoToCrif, LoadingCircle, CustomModal },
  data() {
    return {
      guid: "",
      pdfLocation: "",
      validGuid: false,
      loading: false,
      showModal: false,
      isGemeinschaftskonto: false,
      umfrage: {
        bestehenderKunde: false,
        zeitung: false,
        internet: false,
        durchblicker: false,
        freunde: false,
        sonstige: false,
        sonstige_txt: "",
      },
      showErrorMessage: false,
    };
  },
  computed: {
    fieldsetClass() {
      let fieldsetClass = "mb-2 border p-3 rounded-lg";
      if (this.showErrorMessage && !this.fieldsetOkay) {
        fieldsetClass = fieldsetClass + " bg-red-100";
      }

      console.log(fieldsetClass);

      return fieldsetClass;
    },
    fieldsetOkay() {
      return (
        this.umfrage.bestehenderKunde ||
        this.umfrage.zeitung ||
        this.umfrage.internet ||
        this.umfrage.durchblicker ||
        this.umfrage.freunde ||
        this.umfrage.sonstige
      );
    },
  },
  async mounted() {
    await this.$router.isReady();
    this.guid = this.$route.params.guid;
    this.loadStepFiveInfo();
  },
  methods: {
    Sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
    sendQuestions() {
      if (this.fieldsetOkay) {
        axios
          .post(process.env.VUE_APP_BACKEND_DOMAIN + "questions.php", {
            bestehender_kunde: this.umfrage.bestehenderKunde,
            zeitung: this.umfrage.zeitung,
            internet: this.umfrage.internet,
            durchblicker: this.umfrage.durchblicker,
            freunde: this.umfrage.freunde,
            sonstige: this.umfrage.sonstige,
            sonstige_txt: this.umfrage.sonstige_txt,
            guid: this.guid,
          })
          .then(() => {
            this.$store.dispatch("newResponse", {
              message: "Erfolgreich abgestimmt ✔️",
              success: true,
            });
            this.showModal = false;
          });
      } else {
        this.showErrorMessage = true;
      }
    },
    loadStepFiveInfo() {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_BACKEND_DOMAIN + "create-account.php?step=5", {
          headers: {
            Processid: this.guid,
          },
        })
        .then(async (res) => {
          this.pdfLocation =
            process.env.VUE_APP_BACKEND_DOMAIN + res.data.pdfLocation;

          this.loading = false;
          this.validGuid = true;

          await this.Sleep(300);
          this.showModal = true;
          this.isGemeinschaftskonto = res.data.gemeinschaftskonto;
        })
        .catch((e) => {
          console.log(e);
          this.validGuid = false;
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.success-page {
  text-align: center;
  padding: 30px;
  max-width: 1000px;
  margin: auto;
  font-family: Arial, sans-serif;
}

.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.centered-icon {
  width: 80px;
}

.description {
  font-size: 18px;
  margin-bottom: 30px;
}
.icon-circle svg {
  width: 50px;
  height: 50px;
  display: block;
}

.icon-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 60px;
  margin-bottom: 30px;
}
p {
  color: #7a7a7a;
}
.icon-item {
  text-align: center;
  flex: 1 1 200px;
  max-width: 290px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
}

.icon-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 6px solid #f9b218;
  border-radius: 50%;
  padding: 15px;
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
}

.icon-item h3 {
  color: #f9b218;
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 18px;
}

.icon-item p {
  font-size: 14px;
  color: #7a7a7a;
}
</style>
